module.exports = __webpack_public_path__ + "static/media/warning.b11a1cbf.svg";